import { Button } from "@/components/ui/button";
import { OnlineDot } from "@/components/OnlineDot";
import { PhotoCarousel } from "@/components/PhotoCarousel";
import { MapPin } from "lucide-react";

export function MatchedPropertyCard({ prop: m, onInterest }) {
  return (
    <div className="bg-white border border-border rounded-sm overflow-hidden" data-testid={`matched-property-${m.id}`}>
      <PhotoCarousel images={m.images} alt={m.title} heightClass="h-40" testid={`prop-carousel-${m.id}`} />
      <div className="p-5">
        <div className="flex items-start justify-between gap-2">
          <div className="font-display font-semibold">{m.title}</div>
          <OnlineDot online={m.landlord_online} />
        </div>
      <div className="text-xs text-muted-foreground mb-2">{m.address}, {m.city}</div>
      <div className="text-sm">${m.rent}/mo · {m.bedrooms} bed · {m.bathrooms || 1} bath · {m.lease_length_months}mo</div>
      {m.distance_miles != null && (
        <div className="text-xs text-primary font-medium mt-1 flex items-center gap-1"><MapPin className="w-3 h-3" /> {m.distance_miles} mi away</div>
      )}
      {m.amenities?.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2 items-center">
          {m.amenity_match_pct != null && m.amenity_match_pct < 100 && (
            <span className="text-[10px] font-semibold text-emerald-700 mr-1">{m.amenity_match_pct}% match</span>
          )}
          {m.amenities.slice(0, 4).map((a) => (<span key={a} className="text-[10px] bg-secondary text-secondary-foreground px-2 py-0.5 rounded-full">{a}</span>))}
          {m.amenities.length > 4 && <span className="text-[10px] text-muted-foreground">+{m.amenities.length - 4}</span>}
        </div>
      )}
      <Button size="sm" variant={m.interested ? "outline" : "default"} disabled={m.interested} className="w-full mt-3" data-testid={`interest-${m.id}`} onClick={() => onInterest(m.id)}>
        {m.interested ? "Interest sent" : "I'm interested"}
      </Button>
      </div>
    </div>
  );
}
